/** One colour per trigger for snapshot windows, chips and lane groups (Analysis + Live). */

// Warm/saturated hues that stay readable as translucent bands over the parameter lines.
export const TRIGGER_PALETTE = ["#f97316", "#e879f9", "#2dd4bf", "#facc15", "#a78bfa", "#fb7185", "#a3e635", "#38bdf8", "#f472b6", "#c084fc"];

export type TriggerColors = Record<string, string>;

/** Assign palette colours by sorted name so each trigger keeps its colour across runs, pages and reloads. */
export function triggerColorMap(names: Iterable<string>): TriggerColors {
  const sorted = [...new Set(names)].sort();
  const out: TriggerColors = {};
  sorted.forEach((n, i) => (out[n] = TRIGGER_PALETTE[i % TRIGGER_PALETTE.length]));
  return out;
}

/** Colour for a trigger; names outside the map (e.g. from an older run) get a stable hash-based colour. */
export function triggerColor(name: string, map: TriggerColors): string {
  const c = map[name];
  if (c) return c;
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return TRIGGER_PALETTE[h % TRIGGER_PALETTE.length];
}
